import React from 'react'

import Intro from './Intro.jsx'
import Outro from './Outro.jsx'
import SeasonalityByCategory from './SeasonalityByCategory.jsx'
import Seasonality from './Seasonality.jsx'
import AudienceComparison from './AudienceComparison.jsx'
import AudienceTrend from './AudienceTrend.jsx'
import CompetitiveLandscape from './CompetitiveLandscape.jsx'
import Sentiment from './Sentiment.jsx'
import EntityComparison from './EntityComparison.jsx'
import Transition from './Transition.jsx'
import RecommendedSegments from './RecommendedSegments.jsx'
import PassionPoints from './PassionPoints.jsx'
import TopIndexingStates from './TopIndexingStates.jsx'
import DeviceUsage from './DeviceUsage.jsx'
import PreferredSocialChannels from './PreferredSocialChannels.jsx'
import SharethisOverview from './SharethisOverview.jsx'
import Marketing from './Marketing.jsx'
import TopicsCloud from './TopicsCloud.jsx'
import CategoryCloud from './CategoryCloud.jsx'
import AudienceOverview from './AudienceOverview.jsx'
import IncomeDistribution from './IncomeDistribution.jsx'
import IncomeByAgeAndGender from './IncomeByAgeAndGender.jsx'
import IncomeByAge from './IncomeByAge.jsx'
import IncomeByGender from './IncomeByGender.jsx'

const templates = {
  Intro,
  Outro,
  Seasonality_by_Category: SeasonalityByCategory,
  Seasonality,
  Audience_Comparison: AudienceComparison,
  Audience_Trend: AudienceTrend,
  Sentiment,
  Competitive_Landscape: CompetitiveLandscape,
  Entity_Comparison: EntityComparison,
  Transition,
  Recommended_Segments: RecommendedSegments,
  L2_Categories_and_L3_Categories: PassionPoints,
  Top_Indexing_States: TopIndexingStates,
  Device_and_Mobile_OS: DeviceUsage,
  Social_Networks: PreferredSocialChannels,
  ShareThis_Overview: SharethisOverview,
  Marketing_1: (props) => <Marketing slideNum={1} {...props} />,
  Marketing_2: (props) => <Marketing slideNum={2} {...props} />,
  Marketing_3: (props) => <Marketing slideNum={3} {...props} />,
  Marketing_4: (props) => <Marketing slideNum={4} {...props} />,
  Marketing_5: (props) => <Marketing slideNum={5} {...props} />,
  Marketing_6: (props) => <Marketing slideNum={6} {...props} />,
  Topics_Cloud: TopicsCloud,
  L2_and_L3_Categories_WordCloud: CategoryCloud,
  Audience_Overview: AudienceOverview,
  Income_Distribution: IncomeDistribution,
  Income_Distribution_by_Age_and_Gender: IncomeByAgeAndGender,
  Income_Distribution_by_Age: IncomeByAge,
  Income_Distribution_by_Gender: IncomeByGender,
}

export default templates
